import { render, staticRenderFns } from "./at-popup.vue?vue&type=template&id=20425c99&"
import script from "./at-popup.vue?vue&type=script&lang=js&"
export * from "./at-popup.vue?vue&type=script&lang=js&"
import style0 from "./at-popup.vue?vue&type=style&index=0&id=20425c99&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports